import { Percent } from '@cowprotocol/currency'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

// 30 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 30

export const ONE_HUNDRED_PERCENT = new Percent('1')
